export default __webpack_public_path__ + "static/1118-5810b28392772561534662717e9697bf.gif";